<template>
  <v-container>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.back()"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("reliability.backbtn") }}</span>
    </v-tooltip>
    <base-material-card
      icon="mdi-clipboard-text-outline"
      color="primary"
      inline
      v-if="equipmentProfile"
      class="mt-12 px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="title text-no-wrap font-weight-bold">
          {{ $t("reliability.create") }}
        </div>
      </template>
      <v-card-text>
        <validation-observer v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(validateForm)">
            <v-row justify="center" align="center">
              <v-col cols="12" sm="6" justify="center" align="center">
                <v-chip label class="ma-2" color="secondary"
                  >{{ $t("reliability.equipmentTag") }}
                </v-chip>
                {{ equipmentProfile.equipTag }}
                <br />
                <v-chip label class="ma-2" color="secondary"
                  >{{ $t("reliability.equipmentType") }}
                </v-chip>
                {{ filterEquipmentType(equipmentProfile.equipmentType) }}
              </v-col>

              <v-col
                cols="12"
                sm="6"
                justify="center"
                align="center"
                class="d-flex justify-center align-center"
              >
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  :name="$t('reliability.status')"
                >
                  <v-select
                    validate-on-blur
                    :error-messages="errors"
                    item-text="translation"
                    item-value="value"
                    :label="$t('reliability.status')"
                    :items="status"
                    return-object=""
                    v-model="reliability.status"
                  >
                    <template v-slot:prepend>
                      <v-icon
                        :color="
                          reliability.status
                            ? reliability.status.color
                            : '#008450'
                        "
                        >mdi-circle</v-icon
                      >
                    </template></v-select
                  ></validation-provider
                ></v-col
              >

              <v-col
                v-if="running"
                cols="12"
                sm="6"
                md="4"
                justify="center"
                align="center"
                class="d-flex justify-center align-center"
              >
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  :name="$t('reliability.lblmechanical')"
                >
                  <v-select
                    validate-on-blur
                    :error-messages="errors"
                    :hint="$t('reliability.hint2')"
                    persistent-hint=""
                    item-text="translation"
                    item-value="value"
                    :label="$t('reliability.lblmechanical')"
                    :items="trafficLight"
                    return-object=""
                    v-model="selectedTrafficLight"
                  >
                    <template v-slot:prepend>
                      <v-icon
                        :color="
                          selectedTrafficLight && selectedTrafficLight.color
                            ? selectedTrafficLight.color
                            : '#008450'
                        "
                        >mdi-circle</v-icon
                      >
                    </template></v-select
                  ></validation-provider
                >
              </v-col>

              <v-col cols="12" sm="6" md="4" justify="center" align="center">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="Report Date And Time"
                >
                  <v-datetime-picker
                    :textFieldProps="{
                      errorMessages: errors,
                      validateOnBlur: true
                    }"
                    :datePickerProps="{
                      max: maxDate
                    }"
                    :label="$t('reliability.lblselectdate')"
                    v-model="reliability.datetime"
                  >
                    <template slot="dateIcon">
                      <v-icon>mdi-calendar</v-icon>
                    </template>
                    <template slot="timeIcon">
                      <v-icon>mdi-clock</v-icon>
                    </template>
                    <template slot="actions" slot-scope="{ parent }">
                      <v-btn
                        color="white"
                        text
                        @click.native="parent.clearHandler"
                        >{{ $t("reliability.datepicker.cancelbtn") }}</v-btn
                      >
                      <v-btn color="primary" @click="parent.okHandler">{{
                        $t("reliability.datepicker.okbtn")
                      }}</v-btn>
                    </template>
                  </v-datetime-picker></validation-provider
                >
              </v-col>

              <v-col cols="12" justify="center" align="center"
                ><v-textarea
                  counter
                  row-height="30"
                  filled
                  :hint="$t('reliability.hint1')"
                  persistent-hint=""
                  v-model="reliability.comment"
                  :label="$t('equipmentProfile.comment')"
                ></v-textarea
              ></v-col>
            </v-row>

            <v-card-actions class="mt-12 mb-4">
              <v-spacer></v-spacer>
              <v-btn
                width="250"
                :x-large="$vuetify.breakpoint.mdAndUp"
                primary
                type="submit"
                rounded
                color="primary"
                >{{ $t("reliability.submit") }}</v-btn
              ><v-spacer></v-spacer
            ></v-card-actions></form></validation-observer
      ></v-card-text> </base-material-card
  ></v-container>
</template>

<script>
import { db } from "@/plugins/db";
import { mapState } from "vuex";

import equipmentType from "@/mixins/equipmentType";
export default {
  mixins: [equipmentType],

  data() {
    return {
      reliability: {
        status: {
          name: "Running",
          color: "#008450",
          value: 1,
          translation: this.$t("reliability.statuslights.running")
        },
        datetime: new Date()
      },
      selectedTrafficLight: {},

      status: [
        {
          name: "Running",
          color: "#008450",
          value: 1,
          translation: this.$t("reliability.statuslights.running")
        },
        {
          name: "Standby",
          color: "#EFB700",
          value: 2,
          translation: this.$t("reliability.statuslights.standby")
        },
        {
          name: "Maintenance",
          color: "#DA530A",
          value: 3,
          translation: this.$t("reliability.statuslights.maintenance")
        },
        {
          name: "Failure",
          color: "#B81D13",
          value: 4,
          translation: this.$t("reliability.statuslights.failure")
        }
      ],
      trafficLight: [
        {
          name: "Smooth",
          color: "#008450",
          translation: this.$t("reliability.conditions.smooth"),
          value: 1
        },
        {
          name: "Warning",
          color: "#EFB700",
          translation: this.$t("reliability.conditions.warning"),
          value: 2
        },
        {
          name: "Alarm",
          color: "#B81D13",
          translation: this.$t("reliability.conditions.alarm"),
          value: 3
        }
      ]
    };
  },
  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapState("auth", ["user"]),
    labelSwitch() {
      return this.reliability?.isThisAFailure ? "Yes" : "No";
    },
    maxDate() {
      const today = new Date();
      return this.formatDate(today);
    },
    running() {
      return this.reliability?.status?.name === "Running";
    }
  },
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    await this.$store.dispatch(
      "equipments/bindAnEquipment",
      this.$route.params.equipId
    );
    loading.close();
  },
  methods: {
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    formatHour(date) {
      let hour = `${date.getHours()}`;
      let minutes = `${date.getMinutes()}`;

      if (hour.length < 2) hour = `0${hour}`;
      if (minutes.length < 2) minutes = `0${minutes}`;

      return [hour, minutes].join(":");
    },
    async saveLastStatus(equipmentId) {
      try {
        const lastReliability = await this.$store.dispatch(
          "reliabilities/bindLastReliability",
          equipmentId
        );

        if (lastReliability[0] && lastReliability[0].id) {
          const { id, status } = lastReliability[0];
          let newPayload = {
            db: "equipments",
            data: { status: { id, ...status } },
            doc: this.equipmentProfile.id
          };

          await this.$store.dispatch("updateDocument", newPayload);
        }
      } catch (err) {
        console.error(err);
      }
    },
    async validateForm() {
      const res = await this.$dialog.confirm({
        text: this.$t("dashboard.canYouConfirm"),
        title: this.$t("dashboard.checkFields")
      });
      if (res == true) {
        const loading = this.$vs.loading({
          background: "#730D0B",
          color: "rgb(255, 255, 255)",
          opacity: 1,
          type: "square"
        });

        const status = {
          name: this.reliability.status.name,
          color: this.reliability.status.color,
          value: this.reliability.status.value,
          datetime: new Date(this.reliability.datetime)
        };

        const trafficLight = this.running
          ? {
              name: this.selectedTrafficLight.name,
              color: this.selectedTrafficLight.color,
              value: this.selectedTrafficLight.value
            }
          : null;

        this.reliability.equipmentProfile = db
          .collection("equipments")
          .doc(this.equipmentProfile.id);

        if (status.value === 1) {
          status.trafficLight = trafficLight;
        }

        this.reliability.status = status;
        this.reliability.dateCreated = new Date();
        let payload = {
          db: "reliabilities",
          data: this.reliability
        };

        try {
          let responseUid = await this.$store.dispatch("addDocument", payload);

          await this.saveLastStatus(this.equipmentProfile.id);

          this.$router.push("/reliability/" + responseUid);
        } catch (error) {
          this.$dialog.notify.error(error, {
            position: "top-right",
            timeout: 5000
          });
        }
        loading.close();
      }
    }
  }
};
</script>

<style>
/* Las animaciones de entrada y salida pueden usar */
/* funciones de espera y duración diferentes.      */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
